import { Space } from 'antd'
import { CIMSTags } from 'components/CIMSTags'
import { NameDescription } from './useImplicitPermissions/types'
import { CIMSCollapsePanelOptions } from 'components/CIMSCollapse/types'

export const useRFIResponseDisciplinesPanel = (
  groups: NameDescription[]
): CIMSCollapsePanelOptions[] =>
  !!groups.length
    ? [
        {
          key: `rfi-response-disciplines-${Math.random()}`,
          header: 'Requests For Information',
          children: (
            <Space direction="vertical" size="small">
              {'Response Disciplines:'}
              <CIMSTags
                tags={groups.map(({ name, description }) => ({
                  text: name,
                  tooltip: description,
                }))}
              />
            </Space>
          ),
        },
      ]
    : []
